import React from 'react';
import Link from 'next/link';

interface SafeLinkProps {
  href?: string;
  children: React.ReactNode;
  className?: string;
  onClick?: (e: React.MouseEvent) => void;
}

export function SafeLink({ href, children, className, onClick, ...props }: SafeLinkProps) {
  // If href is undefined, empty, or just a fragment, render a span instead
  if (!href || href === '#' || href.startsWith('#')) {
    return (
      <span 
        className={className} 
        onClick={onClick}
        style={{ cursor: onClick ? 'pointer' : 'default' }}
        {...props}
      >
        {children}
      </span>
    );
  }

  // For valid hrefs, use Next.js Link
  return (
    <Link href={href} className={className} onClick={onClick} {...props}>
      {children}
    </Link>
  );
}